import "core-js/modules/es.function.name";
import { defineMessages } from 'react-intl';
import { composeValidators, requiredValidator, validateFields } from 'validators';
var messages = defineMessages({
  invalidLocation: {
    id: 'location-modal.validations.invalidLocation',
    defaultMessage: 'Please provide a valid location.'
  }
});
export function locationValidator(loc) {
  if (loc && !(loc.lat && loc.lon && loc.name)) {
    return messages.invalidLocation;
  }
}
export var LocationFormValidator = composeValidators(validateFields(requiredValidator, ['location']), validateFields(locationValidator, ['location']));